// Client V2 common imports
module.exports = require('client-v2/common/containers/feed/actions').defaultFeedActions
